<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="FACTURAS" key="1">
          <g-master name="fmo_invoices"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    modalWidth="90%"
          >
            <template slot="expandedRowRender" slot-scope="{text}">
              <template v-for="ve in master.valoresExpandidos">
                {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
              </template>
            </template>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[8,8]">
                <a-col v-bind="colOptions">
                  <g-dropdown :label="$t('Compañía')"
                              :formItemConfig="fiOptions"
                              endpoint="company"
                              :decorator="['id_company', { rules: [{ required: true, message: 'Valor requerido' }]}]">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown :label="$t('PERSONALIZACION_CENTRO_COSTO_CENTRO_DE_COSTOS')"
                              :formItemConfig="fiOptions"
                              endpoint="cc"
                              :decorator="['cc_id', { rules: [{ required: true, message: 'Valor requerido' }]}]">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('N° Factura')">
                    <a-input
                      v-decorator="['id_num_invoice', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Estado')"
                              :formItemConfig="fiOptions"
                              :decorator="['invoice_status', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                              :params="invoice_status">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown :label="$t('Id Tercero')"
                              :formItemConfig="fiOptions"
                              endpoint="third"
                              :decorator="['id_third', { rules: [{ required: true, message: 'Valor requerido' }]}]">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown :label="$t('Id Vendedor')"
                              :formItemConfig="fiOptions"
                              endpoint="third"
                              :decorator="['id_vendor', { rules: [{ required: true, message: 'Valor requerido' }]}]">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Resolución de factura')">
                    <a-input
                      v-decorator="['invoice_resolution', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Año')" v-bind="fiOptions">
                    <a-select v-decorator="['year', { rules: [
                            { required: true, message: 'Valor requerido' },
                           ] }]" style="width: 100%">
                      <a-select-option v-for="year_ in years" :key="year_">
                        {{ year_ }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Mes')" v-bind="fiOptions">
                    <a-select v-decorator="['month', { rules: [
                            { required: true, message: 'Valor requerido' },
                           ] }]" style="width: 100%">
                      <a-select-option v-for="month_ in 12" :key="month_">
                        {{ month_ }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown :label="$t('Periodo')"
                              :formItemConfig="fiOptions"
                              endpoint="hierarchy_lookup"
                              :decorator="['period', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :params="period_request">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Fecha de factura')" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   v-decorator="['invoice_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Moneda de la factura')"
                              :formItemConfig="fiOptions"
                              :decorator="['invoice_currency', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                              :params="code_currency">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Importe de la Factura')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['invoice_ammount', { rules: [{ required: false}] }]"
                                    :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Factura TRM')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['invoice_trm', { rules: [{ required: false}] }]"
                                    :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Impuesto Sobre la Factura')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['invoice_tax', { rules: [{ required: false}] }]"
                                    :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Total Factura')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['invoice_total', { rules: [{ required: false}] }]"
                                    :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Impuesto retefuente')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['tax_ret_fuente', { rules: [{ required: false}] }]"
                                    :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Impuesto reteica')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['tax_ret_ica', { rules: [{ required: false}] }]"
                                    :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Impuesto reteiva')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['tax_ret_iva', { rules: [{ required: false}] }]"
                                    :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Impuesto reteatt1')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['tax_ret_att1', { rules: [{ required: false}] }]"
                                    :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Impuesto reteatt2')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['tax_ret_att2', { rules: [{ required: false}] }]"
                                    :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Impuesto reteatt3')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['tax_ret_att3', { rules: [{ required: false}] }]"
                                    :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Pago de factura')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['invoice_payment', { rules: [{ required: false}] }]"
                                    :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Att1">
                    <a-input
                      v-decorator="['invoice_att1', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Att2">
                    <a-input
                      v-decorator="['invoice_att2', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Att3">
                    <a-input
                      v-decorator="['invoice_att3', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="PptO1">
                    <a-input
                      v-decorator="['invoice_ppto1', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="PptO2">
                    <a-input
                      v-decorator="['invoice_ppto2', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="PptO3">
                    <a-input
                      v-decorator="['invoice_ppto3', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Comentario')">
                    <a-textarea autoSize
                                v-decorator="['comments', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-tab-pane>
      </a-tabs>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="LÍNEAS DE FACTURAS" key="1">
          <invoices_lines v-if="idParent" :id_invoice="idParent"></invoices_lines>
          <span v-else>Seleccione una factura para ver más.</span>
        </a-tab-pane>
      </a-tabs>
    </a-row>
  </div>
</template>

<script>
  export default {
    mounted () {
      this.yearsSelect()
    },
    data () {
      return {
        years: [],
        yearToday: parseInt(moment().format('YYYY')),
        code_currency: {
          h_lookup_type: 'MONEDA',
          use_code: true
        },
        invoice_status: {
          h_lookup_type: 'ESTADO_FACTURA',
          use_code: true
        },
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'fmo_invoices',
          modalFieldsSetup: [
            {name: 'invoice_resolution'},
            {name: 'id_company'},
            {name: 'comments'},
            {name: 'id_num_invoice'},
            {name: 'id_third'},
            {name: 'id_vendor'},
            {name: 'invoice_ammount'},
            {name: 'invoice_att1'},
            {name: 'invoice_att2'},
            {name: 'invoice_att3'},
            {name: 'invoice_currency'},
            {name: 'invoice_date', type: 'date'},
            {name: 'invoice_payment'},
            {name: 'invoice_ppto1'},
            {name: 'invoice_ppto2'},
            {name: 'invoice_ppto3'},
            {name: 'invoice_status'},
            {name: 'invoice_tax'},
            {name: 'invoice_total'},
            {name: 'invoice_trm'},
            {name: 'year'},
            {name: 'month'},
            {name: 'period'},
            {name: 'tax_ret_att1'},
            {name: 'tax_ret_att2'},
            {name: 'tax_ret_att3'},
            {name: 'tax_ret_fuente'},
            {name: 'tax_ret_ica'},
            {name: 'tax_ret_iva'},
            {name: 'cc_id'}
          ],
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Id factura', dataIndex: 'id_num_invoice', sorter: true},
              {title: 'Tercero', dataIndex: 'doc_third_name', sorter: true},
              {title: 'Vendedor', dataIndex: 'doc_vendor_name', sorter: true},
              {title: 'Resolución', dataIndex: 'invoice_resolution', sorter: true},
              {title: 'Fecha', dataIndex: 'invoice_date_mask', sorter: true},
              {title: 'Compañía', dataIndex: 'company', sorter: true},
              {title: 'Importe de la Factura', dataIndex: 'invoice_ammount', sorter: true}
            ],
            customSlots: ['expandedRowRender'],
            allowSelect: true,
            selectedRows: []
          },
          valoresExpandidos: [
            {label: 'Comentarios', column: 'comments'},
            {label: 'att1', column: 'invoice_att1'},
            {label: 'att2', column: 'invoice_att2'},
            {label: 'att3', column: 'invoice_att3'},
            {label: 'Moneda', column: 'invoice_currency'},
            {label: 'Pago', column: 'invoice_payment'},
            {label: 'ppto1', column: 'invoice_ppto1'},
            {label: 'ppto2', column: 'invoice_ppto2'},
            {label: 'ppto3', column: 'invoice_ppto3'},
            {label: 'Estado', column: 'invoice_status'},
            {label: 'Impuesto', column: 'invoice_tax'},
            {label: 'Total', column: 'invoice_total'},
            {label: 'Trm', column: 'invoice_trm'},
            {label: 'Año', column: 'year'},
            {label: 'Mes', column: 'month'},
            {label: 'Periodo', column: 'period'},
            {label: 'tax_ret_att1', column: 'tax_ret_att1'},
            {label: 'tax_ret_att2', column: 'tax_ret_att2'},
            {label: 'tax_ret_att3', column: 'tax_ret_att3'},
            {label: 'tax_ret_fuente', column: 'tax_ret_fuente'},
            {label: 'tax_ret_ica', column: 'tax_ret_ica'},
            {label: 'tax_ret_iva', column: 'tax_ret_iva'}
          ]
        }
      }
    },
    methods: {
      yearsSelect () {
        for (let i = this.yearToday - 1; i <= (this.yearToday + 5); i++) {
          this.years.push(i)
        }
      }
    },
    computed: {
      idParent () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Fmo/Invoices.vue